import { FC } from 'react';
import { Datepicker, FormItem } from '@getsynapse/design-system';
import { type DateRangeFilter as DateRangeFilterType } from 'types/store/projectsList';
import intl from 'react-intl-universal';
import { rangeDateType } from 'utils/customTypes';
import { toLocalDateString } from 'Pages/ProjectsListPage/helpers/formatters';

interface DateRangeFilterProps {
  label: string;
  selected?: DateRangeFilterType;
  onSelect: (selected: DateRangeFilterType) => void;
}

const DateRangeFilter: FC<DateRangeFilterProps> = ({
  selected,
  onSelect,
  label,
}) => {
  return (
    <FormItem label={label}>
      <div className='w-full flex space-x-4'>
        <Datepicker
          className='w-full'
          startPlaceHolder={intl.get('FILTER_GENERAL.FROM')}
          startDate={selected?.min ? new Date(selected.min) : undefined}
          onPickDate={(date: rangeDateType) => {
            const newDate = date.startDate
              ? toLocalDateString(date.startDate)
              : undefined;
            onSelect({ min: newDate, max: selected?.max });
          }}
          inputProps={{
            'aria-label': `${label} min`,
          }}
          maxDate={selected?.max ? new Date(selected.max) : undefined}
        />
        <Datepicker
          className='w-full'
          startPlaceHolder={intl.get('FILTER_GENERAL.TO')}
          startDate={selected?.max ? new Date(selected.max) : undefined}
          onPickDate={(date: rangeDateType) => {
            const newDate = date.startDate
              ? toLocalDateString(date.startDate)
              : undefined;
            onSelect({ min: selected?.min, max: newDate });
          }}
          inputProps={{
            'aria-label': `${label} max`,
          }}
          minDate={selected?.min ? new Date(selected.min) : undefined}
        />
      </div>
    </FormItem>
  );
};

export default DateRangeFilter;
